import './App.css';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom'
// import Login from './Login.js'
// import Profile from './Profile.js'
import { RequireToken, RequireNoToken } from './Auth.js'
import Router from './routes';

// theme
import ThemeProvider from './theme';

import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';

function App() {
  return (
    <ThemeProvider>
      {/* <ScrollToTop /> */}
      <BaseOptionChartStyle />
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </ThemeProvider>

  );
}
export default App;
